// libraries
import React from 'react'

// components
import Section from '/react4xp/components/Section'
import TextCard from '/react4xp/components/TextCard'

interface TextCardListProps {
	items: {
		tag?: string
		title: string
		content?: string
		img?: {
			src: string
			srcMobile: string
			alt: string
		}
		cta?: {
			text: string
			link: string
			external?: boolean
		}
	}[]
}

export default function TextCardList(props: TextCardListProps) {

	const { items } = props

	return (
		<Section>
			<div className='text-card-list'>
				{items.map((item ,i) => (
					<TextCard key={i} {...item} />
				))}
			</div>
		</Section>
   )
}